module.exports = __webpack_public_path__ + "d428a6fea0987c242805cf5223ef9291.png";